import { render, staticRenderFns } from "./EditableField.vue?vue&type=template&id=3977f0fc&scoped=true&"
import script from "./EditableField.vue?vue&type=script&lang=js&"
export * from "./EditableField.vue?vue&type=script&lang=js&"
import style0 from "./EditableField.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EditableField.vue?vue&type=style&index=1&id=3977f0fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3977f0fc",
  null
  
)

export default component.exports